const MESSAGES = {
  ERROR: {
    NOT_ENOUGH_COINS:
      '🚨 동전 또는 지폐의 개수가 0개 이하라서 충전에 실패했습니다. 🚨',
    NOT_ENOUGH_MONEY: '🚨 돈이 부족해서 상품을 선택할 수 없습니다. 🚨',
  },
};

export default MESSAGES;
